import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => sessionStorage.getItem("admin_token");
export const setToken = (t) => sessionStorage.setItem("admin_token", t);
export const clearToken = () => sessionStorage.removeItem("admin_token");

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const login = (password) => axios.post(`${API}/auth/login`, { password }).then((r) => r.data);

export const fetchContent = () => axios.get(`${API}/content`).then((r) => r.data);
export const saveContent = (data) => axios.put(`${API}/content`, data, auth()).then((r) => r.data);
export const fetchPhotos = () => axios.get(`${API}/photos`).then((r) => r.data);
export const deletePhoto = (id) => axios.delete(`${API}/photos/${id}`, auth()).then((r) => r.data);
export const savePhotoOrder = (items) => axios.put(`${API}/photos/order`, items, auth()).then((r) => r.data);

export const uploadPhoto = (file, captionZh, captionEn, kind = "gallery") => {
  const fd = new FormData();
  fd.append("file", file);
  const q = `caption_zh=${encodeURIComponent(captionZh)}&caption_en=${encodeURIComponent(captionEn)}&kind=${kind}`;
  return axios.post(`${API}/photos/upload?${q}`, fd, auth()).then((r) => r.data);
};

export const fetchLeads = () => axios.get(`${API}/leads`, auth()).then((r) => r.data);
export const createLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const updateLead = (id, status) => axios.patch(`${API}/leads/${id}`, { status }, auth()).then((r) => r.data);
export const deleteLead = (id) => axios.delete(`${API}/leads/${id}`, auth()).then((r) => r.data);

export const photoSrc = (p) => (p.storage_path ? `${API}/files/${p.storage_path}` : p.url);
export const imgSrc = (v) => {
  if (!v) return "";
  if (v.startsWith("/api")) return `${process.env.REACT_APP_BACKEND_URL}${v}`;
  return v;
};

export const slugify = (s) =>
  (s || "").toLowerCase().trim().replace(/[^a-z0-9\u4e00-\u9fa5]+/g, "-").replace(/^-+|-+$/g, "");

export const memberSlug = (m) => m.slug || slugify(m.name_en) || slugify(m.name_zh);

export const focusStyle = (m) => ({ objectPosition: `${m?.focus_x ?? 50}% ${m?.focus_y ?? 30}%` });

export const trackVisit = () => axios.post(`${API}/track`, { path: "/" }).then((r) => r.data);
export const fetchStats = () => axios.get(`${API}/stats`, auth()).then((r) => r.data);
